//() => import('@/pages/home')
export default [
    {
        path: '/',
        name: 'i',
        component: () => import('./components/home/Index.vue'),
        meta: {
            title: '个人中心',
            auth: true,
            verify: true
        }
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('./components/auth/Login.vue'),
        meta: {
            title: '登录',
            auth: true,
            verify: false
        }
    },
    {
        path: '/retrievepwd',
        name: 'retrievepwd',
        component: () => import('./components/auth/RetrievePwd.vue'),
        meta: {
            title: '找回密码',
            auth: true,
            verify: false
        }
    },
    {
        path: '/signup',
        name: 'signup',
        component: () => import('./components/auth/Signup.vue'),
        meta: {
            title: '注册',
            auth: true,
            verify: false
        }
    },
    {
        path: '/cart',
        component: () => import('./components/cart/Index.vue'),
        meta: {
            title: '购物车',
            verify: true
        }
    },
    {
        path: '/recharge_center',
        component: () => import('./components/finance/RechargeCenterOne.vue'),
        meta: {
            title: '充值中心',
            verify: true
        }
    },
    {
        path: '/recharge_success',
        component: () => import('./components/finance/RechargeSuccess.vue'),
        meta: {
            title: '支付成功',
            verify: true
        }
    },
    {
        path: '/pre_order/:order_id',
        component: () => import('./components/pre_order/Index.vue'),
        meta: {
            title: '准备下单',
            verify: true
        }
    },
    {
        path: '/resource',
        meta: {
            title: '媒体',
            unRedirect: true,
            verify: false
        },
        redirect: '/resource/woa',
        component: () => import('./components/resource/Index.vue'),
        children: [
            {
                path: 'news',
                name: 'resource.news',
                meta: {
                    title: '软文推广',
                    verify: true
                },
                component: () => import('./components/resource/news/Index.vue')
            },
            {
                path: 'woa',
                name: 'resource.woa',
                meta: {
                    title: '微信公众号',
                    unRedirect: true,
                    verify: false
                },
                component: () => import('./components/resource/woa/Index.vue')
            },
            {
                path: 'flow',
                name: 'resource.flow',
                meta: {
                    title: '信息流',
                    unRedirect: true,
                    verify: false
                },
                component: () => import('./components/resource/flow/Index.vue')
            },
            {
                path: 'flowPlan',
                name: 'resource.flowPlan',
                meta: {
                    title: '信息流广告投放',
                    unRedirect: true,
                    verify: false
                },
                component: () =>
                    import('./components/resource/flow/flowPlan.vue')
            },
            {
                path: 'weibo',
                name: 'resource.weibo',
                meta: {
                    title: '微博',
                    unRedirect: true,
                    verify: false
                },
                component: () => import('./components/resource/weibo/Index.vue')
            },
            {
                path: 'live',
                name: 'resource.live',
                meta: {
                    title: '直播',
                    unRedirect: true,
                    verify: false
                },
                component: () => import('./components/resource/live/Index.vue')
            },
            {
                path: 'video',
                name: 'resource.video',
                meta: {
                    title: '短视频',
                    unRedirect: true,
                    verify: false
                },
                component: () => import('./components/resource/video/Index.vue')
            },
            {
                path: 'xhs',
                name: 'resource.xhs',
                meta: {
                    title: '小红书',
                    unRedirect: true,
                    verify: false
                },
                component: () => import('./components/resource/xhs/Index.vue')
            }
            // {
            //     path: 'news',
            //     name: 'resource.news',
            //     meta: {
            //         title: '软文推广',
            //         unRedirect: true,
            //         verify: false
            //     },
            //     component: () =>
            //         import ('./components/resource/news/Index.vue')
            // }
        ]
    },
    {
        path: '/own',
        name: 'own',
        component: () => import('./components/own/Index.vue'),
        redirect: '/own/order',
        children: [
            {
                path: 'order',
                name: 'order',
                meta: {
                    title: '订单中心',
                    verify: true
                },
                component: () => import('./components/order/Index.vue')
            },
            {
                path: 'news_order',
                name: 'news_order',
                meta: {
                    title: '软文订单中心',
                    verify: true
                },
                component: () => import('./components/news_order/Index.vue')
            },
            {
                path: 'order/:id',
                name: 'order.show',
                meta: {
                    title: '订单详细',
                    verify: true
                },
                component: () => import('./components/order/Show.vue')
            },
            {
                path: 'order_item',
                name: 'order.item',
                meta: {
                    title: '子订单详情',
                    verify: true
                },
                component: () => import('./components/order/Item.vue')
            },
            {
                path: 'ghostwrite',
                name: 'ghostwrite',
                meta: {
                    title: '文章代写',
                    verify: true
                },
                component: () => import('./components/ghostwrite/Index.vue')
            },
            {
                path: 'ghostwrite/create',
                name: 'ghostwrite.create',
                meta: {
                    title: '新建代写',
                    verify: true
                },
                component: () => import('./components/ghostwrite/Create.vue')
            },
            {
                path: 'manuscripts',
                name: 'manuscript',
                meta: {
                    title: '稿件管理',
                    verify: true
                },
                component: () => import('./components/manuscript/Index.vue')
            },
            {
                path: 'manuscripts/copy_write',
                name: 'copy_write',
                meta: {
                    title: '稿件代写',
                    verify: true
                },
                component: () => import('./components/manuscript/CopyWrite.vue')
            },
            {
                path: 'copy_write',
                name: 'copy_write',
                meta: {
                    title: '文章代写',
                    verify: true
                },
                component: () => import('./components/manuscript/CopyWrite.vue')
            },
            {
                path: 'copy_write_list',
                name: 'copy_write_list',
                meta: {
                    title: '代写列表',
                    verify: true
                },
                component: () => import('./components/copyWriteList/Index.vue')
            },
            {
                path: 'manuscripts/:id/edit/woa',
                name: 'manuscript.edit.woa',
                meta: {
                    title: '稿件修改',
                    _meta: 'edit',
                    verify: true
                },
                component: () =>
                    import(/* webpackChunkName: "manuscriptsEditWoa" */ './components/manuscript/create/Woa.vue')
            },
            {
                path: 'manuscripts/:id/edit/weibo',
                meta: {
                    title: '稿件修改',
                    _meta: 'edit',
                    verify: true
                },
                component: () =>
                    import(/* webpackChunkName: "manuscriptsWeiboCreate" */ './components/manuscript/create/Weibo.vue')
            },
            {
                path: 'manuscripts/:id/edit/live',
                meta: {
                    title: '稿件修改',
                    _meta: 'edit',
                    verify: true
                },
                component: () =>
                    import(/* webpackChunkName: "manuscriptsWeiboLive" */ './components/manuscript/create/Live.vue')
            },
            {
                path: 'manuscripts/:id/edit/news',
                meta: {
                    title: '稿件修改',
                    _meta: 'edit',
                    verify: true
                },
                component: () =>
                    import('./components/manuscript/create/News.vue')
            },
            {
                path: 'manuscripts/:id/create/news',
                meta: {
                    title: '稿件重发',
                    verify: true
                },
                component: () =>
                    import('./components/manuscript/create/News.vue')
            },
            {
                path: 'manuscripts/:id/edit/video',
                meta: {
                    title: '稿件修改',
                    _meta: 'edit',
                    verify: true
                },
                component: () =>
                    import('./components/manuscript/create/Video.vue')
            },
            {
                path: 'manuscripts/:id/edit/xhs',
                meta: {
                    title: '稿件修改',
                    _meta: 'edit',
                    verify: true
                },
                component: () =>
                    import('./components/manuscript/create/Xhs.vue')
            },
            {
                path: 'manuscripts/create/woa',
                meta: {
                    title: '创建微信公众号稿件',
                    verify: true
                },
                component: () =>
                    import('./components/manuscript/create/Woa.vue')
            },
            {
                path: 'manuscripts/create/live',
                meta: {
                    title: '创建网红直播稿件',
                    verify: true
                },
                component: () =>
                    import('./components/manuscript/create/Live.vue')
            },
            {
                path: 'manuscripts/create/news',
                meta: {
                    title: '创建软文推广稿件',
                    verify: true
                },
                component: () =>
                    import('./components/manuscript/create/News.vue')
            },
            {
                path: 'publish',
                meta: {
                    title: '文章发布',
                    verify: true
                },
                component: () =>
                    import('./components/manuscript/create/News.vue')
            },
            {
                path: 'manuscripts/create/video',
                meta: {
                    title: '创建短视频稿件',
                    verify: true
                },
                component: () =>
                    import('./components/manuscript/create/Video.vue')
            },
            {
                path: 'manuscripts/create/weibo',
                meta: {
                    title: '创建微博稿件',
                    verify: true
                },
                component: () =>
                    import('./components/manuscript/create/Weibo.vue')
            },
            {
                path: 'manuscripts/create/xhs',
                meta: {
                    title: '创建小红书稿件',
                    verify: true
                },
                component: () =>
                    import('./components/manuscript/create/Xhs.vue')
            },
            {
                path: 'finance',
                name: '财务中心',
                component: () => import('./components/finance/Index.vue'),
                redirect: '/own/finance/recharge',
                children: [
                    {
                        path: 'transaction',
                        meta: {
                            title: '交易流水',
                            verify: true
                        },
                        component: () =>
                            import('./components/transaction/Index.vue')
                    },
                    {
                        path: 'transaction/:order_id',
                        meta: {
                            title: '交易明细',
                            verify: true
                        },
                        component: () =>
                            import('./components/transaction/Show.vue')
                    },
                    {
                        path: 'withdrawals',
                        meta: {
                            title: '提现',
                            verify: true
                        },
                        component: () =>
                            import('./components/finance/Withdrawals.vue')
                    },
                    {
                        path: 'invoice',
                        meta: {
                            title: '发票',
                            verify: true
                        },
                        component: () =>
                            import('./components/Invoice/Index.vue')
                    },
                    {
                        path: 'invoice_list',
                        meta: {
                            title: '发票列表',
                            verify: true
                        },
                        component: () =>
                            import('./components/InvoiceList/Index.vue')
                    },
                    {
                        path: 'invoice_info_list',
                        meta: {
                            title: '发票信息审核',
                            verify: true
                        },
                        component: () =>
                            import('./components/invoiceInfoList/Index.vue')
                    },
                    {
                        path: 'invoice/create',
                        meta: {
                            title: '发票信息',
                            verify: true
                        },
                        component: () =>
                            import('./components/Invoice/Create.vue')
                    }
                ]
            },
            {
                path: 'personal',
                component: () => import('./components/personal/Index.vue'),
                children: [
                    {
                        path: 'profile',
                        meta: {
                            title: '个人资料',
                            verify: true
                        },
                        component: () =>
                            import('./components/personal/Profile.vue')
                    },
                    {
                        path: 'password',
                        meta: {
                            title: '密码修改',
                            verify: true
                        },
                        component: () =>
                            import('./components/personal/Password.vue')
                    },
                    {
                        path: 'avatar',
                        meta: {
                            title: '头像上传',
                            verify: true
                        },
                        component: () => import('./components/avatar/Index.vue')
                    },
                    {
                        path: 'mobile',
                        meta: {
                            title: '修改手机号码',
                            verify: true
                        },
                        component: () =>
                            import('./components/personal/Mobile.vue')
                    }
                    //  {
                    //     path: 'collect',
                    //     component: () => import("./components/personal/Collect.vue"),
                    //     meta: {
                    //         title: "收藏中心"
                    //     }
                    // }
                ]
            }
        ]
    },
    {
        path: '/manuscripts/:id',
        name: 'manuscript_preview',
        meta: {
            title: '稿件预览',
            silent: true,
            verify: false
        },
        component: () => import('./components/manuscript/Show.vue')
    },
    {
        path: '/pay_success',
        name: '支付成功',
        meta: {
            title: '',
            verify: true
        },
        component: () => import('./components/global/PaySuccess.vue')
    },
    {
        path: '/recommand',
        meta: {
            title: '智能推荐'
        },
        component: () => import('./components/recommand/Index.vue')
    },
    {
        path: '/error',
        name: '404',
        meta: {
            title: '404',
            verify: false
        },
        component: () => import('./components/global/404.vue')
    },
    {
        path: '/manuscript_edit/:key',
        meta: {
            title: '编辑器',
            silent: true,
            verify: false
        },
        component: () => import('./components/editor/Index.vue')
    },
    {
        path: '*',
        redirect: '/error'
    }
]



// WEBPACK FOOTER //
// ./src/Routes.js